// extracted by mini-css-extract-plugin
export default {"ProgressDays":"styles_ProgressDays__1Ba9n","values":"styles_values__QpC5S","data":"styles_data__LqIPH","navButton":"styles_navButton__YUbt4"};